import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { SharedService } from 'src/app/services/shared.service';
import { AdministrationService } from 'src/app/services/administration.service';
import { MatSnackBar, MatDialogRef, MatDialog } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { NationalUser } from 'src/app/models/nationalUser';
import { ProgressSpinnerDialogComponent } from 'src/app/progress-spinner-dialog/progress-spinner-dialog.component';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-national-user-detail',
  templateUrl: './national-user-detail.component.html',
  styleUrls: ['./national-user-detail.component.scss']
})
export class NationalUserDetailComponent implements OnInit {

  userId: string;
  resetPasswordForm: FormGroup;
  nationalUserForm: FormGroup;
  nationalUser: NationalUser;
  showEditFrom = true;
  showResetPasswordForm = false;
  dialogRef: MatDialogRef<ProgressSpinnerDialogComponent>;
  gender: [];
  membershipFees = [
    "Graded Rider as per DA's => R50-00",
    "Recreational member => Free",
    "Officials => Free"
  ];


  constructor(
    private fb: FormBuilder,
    private sharedService: SharedService,
    private adminService: AdministrationService,
    private snackBar: MatSnackBar, private router: Router, private route: ActivatedRoute,
    private dialog: MatDialog, private authService: AuthenticationService) { }

  ngOnInit() {
    this.userId = this.route.snapshot.paramMap.get('id').toString();
    let dialogRef: MatDialogRef<ProgressSpinnerDialogComponent> = this.dialog.open(ProgressSpinnerDialogComponent, {
      panelClass: 'transparent',
      disableClose: true
    });
    this.sharedService.GetGenders().subscribe((result: []) => {
      this.gender = result;
    });
    this.adminService.GetNationalUserById(this.userId).subscribe((result: NationalUser) => {
      this.nationalUser = result;
      this.updateForm();
      dialogRef.close();
      this.resetPasswordForm = this.fb.group({
        userId: new FormControl(this.userId),
        password: new FormControl('', [Validators.required, Validators.minLength(8)])
      });
    }, error => {
      dialogRef.close();
    });
    this.buildForm();
  }

  buildForm() {
    this.nationalUserForm = this.fb.group({
      userId               : new FormControl(''),
      userName             : new FormControl('', [Validators.required]),
      firstName            : new FormControl('', [Validators.required]),
      lastName             : new FormControl('', [Validators.required]),
      password: new FormControl('', ),
      email: new FormControl('', [Validators.required]),
      mobileNumber: new FormControl('', [Validators.required]),
      membershipFees: new FormControl(0, [Validators.required]),
      dateOfBirth: new FormControl('', [Validators.required]),
      genderId: new FormControl('', [Validators.required]),
      saefRegistrationNumber: new FormControl(''),
      sanesaNo: new FormControl(''),
      sawgaNo: new FormControl(''),
      sasaNo: new FormControl(''),
      dsaNo: new FormControl(''),
      sasjNo: new FormControl(''),
      saeqaNo: new FormControl(''),
      otherNo               : new FormControl(''),
      terms                 : new FormControl(true),
      isAdmin               : new FormControl(false),
      addDisciplineName     : new FormControl(''),
      addDisciplineNumber   : new FormControl(''),
      memberNo :new FormControl('')
    });
  }

  updateForm() {
    this.nationalUserForm.get('password').setValidators(null);
    this.nationalUserForm.setValue({
      userName: this.nationalUser.userName,
      userId: this.nationalUser.userId,
      firstName: this.nationalUser.firstName,
      lastName: this.nationalUser.lastName,
      mobileNumber: this.nationalUser.mobileNumber,
      email: this.nationalUser.email,
      password: null,
      membershipFees: this.nationalUser.membershipFees,
      dateOfBirth: this.nationalUser.dateOfBirth,
      genderId: this.nationalUser.genderId,
      saefRegistrationNumber: this.nationalUser.saefRegistrationNumber,
      sanesaNo: this.nationalUser.sanesaNo,
      sawgaNo: this.nationalUser.sawgaNo,
      sasaNo: this.nationalUser.sasaNo,
      dsaNo: this.nationalUser.dsaNo,
      sasjNo: this.nationalUser.sasjNo,
      saeqaNo: this.nationalUser.saeqaNo,
      otherNo: this.nationalUser.otherNo,
      terms: this.nationalUser.terms,
      isAdmin: this.nationalUser.isAdmin,
      addDisciplineName : this.nationalUser.addDisciplineName,
      addDisciplineNumber : this.nationalUser.addDisciplineNumber   ,
      memberNo : this.nationalUser.memberNo
    });
  }

  onBackClick() {
    this.router.navigate(['./users/']);
  }

  onSubmit() {
    if (this.nationalUserForm.invalid) {
      return;
    }
    let dialogRef: MatDialogRef<ProgressSpinnerDialogComponent> = this.dialog.open(ProgressSpinnerDialogComponent, {
      panelClass: 'transparent',
      disableClose: true
    });
    this.adminService.AddOrUpdateNationalUser(this.nationalUserForm.value).subscribe(res => {
      this.router.navigate(['/users'], { relativeTo: this.route });
      dialogRef.close();
      this.snackBar.open(this.userId === '-1' ? 'user created.' : 'user updated.', '', {
        duration: 2000,
        panelClass: ['global-snackbar']
      });
    }, error => {
      dialogRef.close();
      this.snackBar.open(this.userId === '-1' ? 'Error creating  user.' : 'Error updating user.', '', {
        duration: 2000,
        panelClass: ['global-error']
      });
    });
  }

  toggleResetPassword() {
    this.showEditFrom = !this.showEditFrom;
    this.showResetPasswordForm = !this.showResetPasswordForm;
    this.resetPasswordForm.patchValue({ password: "" });
  }

  onResetPassword() {
    this.dialogRef = this.dialog.open(ProgressSpinnerDialogComponent, {
      panelClass: 'transparent',
      disableClose: true
    });
    let userId = this.resetPasswordForm.get("userId").value;
    let password = this.resetPasswordForm.get("password").value;
    this.authService.resetPassword(userId, password).subscribe(result => {
      this.dialogRef.close();
      this.toggleResetPassword();
      this.snackBar.open('Password successfully changed.', '', {
        duration: 2000,
        panelClass: ['global-snackbar']
      });
    }, error => {
      this.dialogRef.close();
      this.snackBar.open('Error changing password.', '', {
        duration: 2000,
        panelClass: ['global-error']
      });
    });
  }

  onDelete(){
    let dialogRef: MatDialogRef<ProgressSpinnerDialogComponent> = this.dialog.open(ProgressSpinnerDialogComponent, {
      panelClass: 'transparent',
      disableClose: true
    });
    this.adminService.removeMember(this.userId).subscribe(res => {
      dialogRef.close();
      this.router.navigate(['/users/'], { relativeTo: this.route });
      this.snackBar.open('Member Deleted', '', {
        duration: 2000,
        panelClass: ['global-snackbar']
      });
    }, error => {
      dialogRef.close();
      this.snackBar.open('Error deleting member', '', {
        duration: 2000,
        panelClass: ['global-error']
      });
    });
  }

  onActiveInActiveClick() {
    let dialogRef: MatDialogRef<ProgressSpinnerDialogComponent> = this.dialog.open(ProgressSpinnerDialogComponent, {
      panelClass: 'transparent',
      disableClose: true
    });
    this.adminService.ToggleMemberActive(this.userId).subscribe(res => {
      dialogRef.close();
      this.router.navigate(['/users/'+ this.userId], { relativeTo: this.route });
      this.snackBar.open(this.nationalUser.isActive ? 'Member marked as inactive.' : 'Member marked as active.', '', {
        duration: 2000,
        panelClass: ['global-snackbar']
      });
    }, error => {
      dialogRef.close();
      this.snackBar.open(this.nationalUser.isActive ? 'Error marking member as inactive.' : 'Error  marking member as active.', '', {
        duration: 2000,
        panelClass: ['global-error']
      });
    });
  }

}
